var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.loading)?_c('div',{staticClass:"loader"},[_c('v-sheet',{attrs:{"height":"100%"}},[_c('v-progress-circular',{attrs:{"size":"50","indeterminate":""}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }